import React from 'react';
import { logClientError } from '../services/logging';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    logClientError({
      error,
      info,
      user: this.props.user,
      route: window.location.pathname,
    });
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="safe-mode">
          <div className="safe-mode__card">
            <h1>Safe mode</h1>
            <p>Something went wrong. We recorded the error and kept your session safe.</p>
            <button onClick={this.handleReload}>Reload</button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
